export default "__VITE_ASSET__Bb4471yy__"